import { render, staticRenderFns } from "./Permissao.vue?vue&type=template&id=1c4d79a4&scoped=true"
import script from "./Permissao.vue?vue&type=script&lang=ts"
export * from "./Permissao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d79a4",
  null
  
)

export default component.exports